<app-replacement-claim-overview [filter]="'ordered'" [pageTitle]="'Bevestigde vervangingsaanvragen'"></app-replacement-claim-overview>
